export default __webpack_public_path__ + "static/media/meal-2.10bc6027.svg";